export default function orderByName(a, b) {
  if (a.name === b.name) {
    return 0;
  }
  return a.name.localeCompare(b.name);
}
